import { render, staticRenderFns } from "./SaleDetails.vue?vue&type=template&id=236d50ce&scoped=true"
import script from "./SaleDetails.vue?vue&type=script&lang=js"
export * from "./SaleDetails.vue?vue&type=script&lang=js"
import style0 from "./SaleDetails.vue?vue&type=style&index=0&id=236d50ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236d50ce",
  null
  
)

export default component.exports